export const ApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "https://clinic-api.khalidelewa.com";
export const ApiBaseUrl2 = process.env.REACT_APP_API_BASE_URL2 || "https://clinic-api.khalidelewa.com";
export const ImageBaseUrl = ApiBaseUrl;
